import React, {Component} from 'react';
import MenuList from "../../../view/sysManagement/organizationalStructure/menu/MenuList";
import ContentWrap from "../../../view/sysManagement/components/ContentWrap";
import TreeAndTableLayout from "../../../components/TreeAndTableLayout/TreeAndTableLayout";
import MenuToolBar from "./MenuToolBar";
import {InputNumber, Popconfirm} from "antd";
import MenuEditModal from "./MenuEditModal";
import DragSort from "../../dragSortComponent/DragSort";
import {message} from "../../../view/sysManagement/utils/sysManagementUtils"

class ColumnList extends MenuList {

    constructor(props) {
        super(props);
        this.mediaId = this.props.match.params.mediaId ? this.props.match.params.mediaId : '';
        this.state.selectedItemInfo = {}
    }

    tableColumnIndex = {
        optionSort: "sort",
        code: "columnCode"
    };

    getColumns = () => {
        const columns = [
            {
                title: "封面",
                dataIndex: "url",
                width: 160,
                align:"center",
                render:(url)=>{
                    return url ? <img src={url} width={58} height={38} style={{objectFit: "contain"}}/>: "-";
                }
            },
            {
                title: "栏目名称",
                dataIndex: "name",
                width: 180,
                ellipsis: true,
                render: (text, record) => {
                    let ico;
                    // 判断是显示移动端还是PC端ico
                    if (record.clientTypes && record.clientTypes.length === 1) {
                        if (record.clientTypes.indexOf(0) > -1) {
                            ico = record.ico
                        } else if (record.clientTypes.indexOf(1) > -1) {
                            ico = record.mobileIco
                        }
                    } else if (record.clientTypes && record.clientTypes.length > 1) {
                        if (record.clientTypes.indexOf(0) > -1) {
                            ico = record.ico
                        }
                    }
                    if (ico) {
                        return <div style={{
                            display: "flex",
                            alignItems: "center"
                        }}>
                            <div
                                style={{
                                    flex: "0 0 18px",
                                    height: "18px",
                                    backgroundImage: `url(${ico})`,
                                    backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    marginRight: "8px"
                                }}
                            >
                            </div>
                            <span>{text}</span>
                        </div>;
                    } else if (!(record.ico||record.mobileIco) && record.svg||record.mobileSvg) {
                        return (
                            <>
                                <div className={'iconStyle'} style={{
                                    display: "flex",
                                    alignItems: "center"
                                }}>
                                    <div style={{
                                        flex: "0 0 18px",
                                        height: "18px",
                                        width: "18px",
                                        marginRight: "8px"
                                    }}
                                         dangerouslySetInnerHTML={{__html: record.svg||record.mobileSvg}}
                                    />
                                    <span>{text}</span>
                                </div>
                                <style>{`
                                .iconStyle .icon{
                                    height: 18px !important;
                                    width: 18px !important;
                                    vertical-align: sub;
                                }
                                `}</style>
                            </>
                        )
                    } else {
                        return <span>{text}</span>;
                    }
                }
            },
            {
                title: "栏目编码",
                dataIndex: this.tableColumnIndex.code,
                width: 180,
                ellipsis: true
            },
            {
                title: "栏目类型",
                dataIndex: "type",
                width: 160,
                render: (text) => {
                    let map = {
                        "1": "普通栏目",
                        "2": "专题栏目",
                        "3": "视频栏目",
                    };
                    return map[text];
                }
            },
            // {
            //     title: "排序",
            //     dataIndex: this.tableColumnIndex.optionSort,
            //     ellipsis: true,
            //     width: 160,
            //     render: (text, record) => {
            //         return (
            //             <>
            //                 {this.state.isUpdateSort ?
            //                     <InputNumber style={{width: '60px'}} min={0} max={99999}
            //                                  parser={value => value.replace(/\D/g, '')}
            //                                  defaultValue={record[this.tableColumnIndex.optionSort] >= 0 ? record[this.tableColumnIndex.optionSort] : 10}
            //                                  onChange={(value) => this.onChangeNum(value, record)}/> :
            //                     <div>{record[this.tableColumnIndex.optionSort] >= 0 ? record[this.tableColumnIndex.optionSort] : 10}</div>
            //                 }
            //             </>
            //         )
            //     }
            // },
            {
                title: "浏览限制",
                dataIndex: "permissionType",
                width: 200,
                render: (text) => {
                    let map = {
                        "1": "公开",
                        "2": "仅内部员工可见",
                        "3": "仅内部管理人员可见",
                    };
                    return map[text];
                }
            },
            {
                title: "操作",
                width: 160,
                render: (text, record) => {
                    return <>
                        {record.deletePermission ?
                            <span>
                                <span className="cm-link margin-right-15"
                                      onClick={() => this.showMenuEdit({...record, treeData: this.state.selectedItemInfo})}>修改</span>
                                <Popconfirm
                                    title={`确定删除栏目：${record.menuName}`}
                                    onConfirm={() => this.deleteMenu(record)}
                                    okText="确定"
                                    cancelText="取消"
                                >
                                    <span className="cm-link">删除</span>
                                </Popconfirm>
                            </span> : "-"}
                    </>
                }
            }
        ];
        this.setState({
            columns
        });
    };

    onTreeSelect = (selectKeys, e) => {
        let selectedItem = e.node.props.dataRef.data;
        this.setState({
            currentPage: 1,
            selectedKeys: selectKeys,
            searchValue: ""
        }, () => {
            this.getTableData();
            this.getColumnInfo(selectedItem);
        });
    };

    getColumnInfo = (data) => {
        let columnId = data.fid ? data.fid : data.id;
        if (columnId) {
            this.request({
                url: "/cm-sites-mmp/column/findByColumnId",
                method: "post",
                body: {
                    columnId,
                }, callBack: (res) => {
                    let selectedItemInfo = {};
                    if (res) {
                        selectedItemInfo= res;
                    }
                    this.setState({
                        selectedItemInfo
                    })
                }
            });
        }
    };

    render() {
        const {
            selectedKeys,
            treeData,
            pageSize,
            currentPage,
            columns,
            count,
            tableData,
            tableIsLoading,
            searchValue,
            expandedKeys,
            autoExpandParent,
            menuEditModalVisible,
            editMenu,
            selectedItemInfo
        } = this.state;
        return (
            <ContentWrap>
                <TreeAndTableLayout
                    showIcon={true}
                    selectedKeys={selectedKeys}
                    treeData={treeData}
                    expandedKeys={expandedKeys}
                    onExpand={this.onExpand}
                    autoExpandParent={autoExpandParent}
                    onSelect={this.onTreeSelect}
                    pageSize={pageSize}
                    current={currentPage}
                    columns={columns}
                    count={count}
                    tableData={tableData}
                    tableIsLoading={tableIsLoading}

                    onChange={this.onPageChange}
                    onShowSizeChange={this.onShowSizeChange}

                    ToolBar={
                        <MenuToolBar
                            searchValue={searchValue}
                            onSearchValueChange={searchValue => this.setState({ searchValue })}
                            onSearch={this.onSearch}
                            showMenuEdit={() => this.showMenuEdit({ fid: selectedKeys[0], treeData: selectedItemInfo })}
                            showBoundPermission={this.showBoundPermission}
                            isRootNode={this.isRootNode}
                            tableData={this.state.tableData}
                            sortStatusCall={() => {
                                this.setState({isUpdateSort: !this.state.isUpdateSort})
                            }}
                            fid={selectedKeys[0]}
                            onSortCall={() => {
                                this.getTreeData();
                                this.getTableData();
                                this.hideMenuEdit();
                            }}
                            saveSort={this.saveSort}
                            selectedItemInfo={selectedItemInfo}
                        />
                    }
                />
                <MenuEditModal
                    visible={menuEditModalVisible}
                    data={editMenu}
                    handleCancel={this.hideMenuEdit}
                    handleOk={this.submitMenuEdit}
                />
                {/*拖动排序*/}
                <DragSort ref={ref => this.dragSort = ref} mediaId={this.mediaId} treeContentId={selectedKeys[0]} refreshList={() => {
                    this.getTableData();
                    this.getTreeData();
                }}/>
            </ContentWrap>
        );
    }

    addMenu = data => {
        this.addMenuRequest(data, res => {
            if(res) {
                message.success("栏目添加成功");
                this.setState({
                    currentPage: 1
                }, () => {
                    this.getTreeData();
                    this.getTableData();
                    this.hideMenuEdit();
                    this.expandKey(data.fid);
                })
            }
        });
    };

    editMenu = data => {
        this.editMenuRequest(data, (res) => {
            if(res) {
                message.success("栏目修改成功");
                this.getTreeData();
                this.getTableData();
                this.hideMenuEdit();
            }
        });
    };

    deleteMenu = data => {
        this.deleteMenuByIdRequest(data.id, (res) => {
            if(res) {
                message.success("栏目已被删除");
                this.getTreeData();
                if (this.state.tableData.length === 1) {
                    this.onPageChange(this.state.currentPage - 1, this.state.pageSize)
                } else {
                    this.onPageChange(this.state.currentPage, this.state.pageSize)
                }
            }
        });
    };

    /**
     * 文章排序
     */
    saveSort = () => {
        if(!this.state.tableData.length) {
            message.warn("暂无数据！");
            return false;
        }
        this.dragSort.showSortModal();
    };

    /**
     * 显示菜菜单信息
     * @param callBack
     */
    findMenuTreeRequest = callBack => {
        this.request({
            url: "/cm-sites-mmp/column/findMenuTree?mediaId=" + this.mediaId,
            callBack: (data)=>{
                let menu = {
                    id:"0-0",
                    fid: "",
                    menuCode: "",
                    menuName:"全部",
                    child: data
                };
                let convertData = (data)=>{
                    if(data.child && data.child.length > 0){
                        data.child.map(item=>{
                            item.menuCode = item.columnCode;
                            item.menuName = item.columnName;
                            convertData(item);
                        });
                    }
                };
                convertData(menu);
                callBack(menu);
            }
        });
    };

    findListByConditionRequest = ({ pageNum, pageSize, name, menuId }, callBack) => {
        this.request({
            url: "/cm-sites-mmp/column/pageList",
            body: {
                start:pageNum, size:pageSize, queryStr:name, fid:["0","0-0"].indexOf(menuId)>-1?"":menuId, mediaId:this.mediaId
            },
            method: "post",
            // contentType: "json",
            callBack: res => {
                const tableData = res && res.data;
                tableData && tableData.forEach(item => {
                    item.code = item.columnCode;
                    item.name = item.columnName;
                    item.menuCode = item.columnCode;
                    item.menuName = item.columnName;
                });
                callBack(res);
            }
        });
    };

    addMenuRequest = ({ columnName, fid, columnCode, sort, type, showStyle, labels, url, showDetail, status, permissionType, videoShowType }, callBack) => {
        if(fid === '0-0'){
            fid = "";
        }
        this.request({
            url: "/cm-sites-mmp/column/add",
            body: { columnName, fid, columnCode, sort, labels, type, showStyle, mediaId: this.mediaId, url, showDetail, status, permissionType, videoShowType },
            method: "post",
            contentType: "json",
            callBack
        });
    };

    editMenuRequest = ({ id, columnName, fid, columnCode, sort, showStyle, type, labels, url, showDetail, status, permissionType, videoShowType }, callBack) => {
        if(fid === '0-0'){
            fid = "";
        }
        this.request({
            url: "/cm-sites-mmp/column/update",
            body: { id, columnName, fid, columnCode, sort, labels, showStyle, type, mediaId: this.mediaId, url, showDetail, status, permissionType, videoShowType },
            method: "post",
            contentType: "json",
            callBack
        });
    };

    deleteMenuByIdRequest = (menuId, callBack) => {
        this.request({
            url: "/cm-sites-mmp/column/remove",
            body: { columnId:menuId },
            method: "post",
            callBack
        });
    };
}

export default ColumnList;
